import {Navbar} from "./Navbar";
import React, {useContext, useState} from "react";
import {useTranslation} from "react-i18next";
import {AuthContext} from "../utils/AuthProvider";
import {
    Box, Container, Stack,
    Autocomplete,
    AutocompleteOption, Button,
    Card,
    FormControl,
    FormLabel,
    Grid,
    Input, ListItemContent,
    ListItemDecorator,
    Typography
} from "@mui/joy";
import {APIurl, countries} from "../utils/Utils";
import firebase from "firebase/compat/app";


export function BillingDetails() {

    const { i18n, t } = useTranslation();
    const {userData, subscriptions} = useContext(AuthContext)
    const [loading, setLoading] = useState(false);

    const initialBillingDetails = {
        vat: "",
        name: "",
        surname: "",
        country: "IT",
        city: "",
        address: "",
        streetnumber: "",
    }
    const [billingDetails, setBillingDetails] = useState(initialBillingDetails)

    return (
        <Box sx={{height: '100vh'}}>
            <Navbar />
            <Container sx={{py: {xs:"7rem", md:"10rem"}}}>
                <Stack spacing={3}>
                    <Typography level="title-md" fontWeight="bold">{t("billingdetails")}</Typography>
                    <Card>
                        <Grid container spacing={2}>
                            <Grid xs={12} md={4}>
                                <FormControl>
                                    <FormLabel>{t("name")} *</FormLabel>
                                    <Input type="text"
                                           value={billingDetails.name}
                                           onChange={e => {setBillingDetails({...billingDetails, name: e.target.value})}}
                                           placeholder={t("name")}
                                           error={billingDetails.name.trim() === ""}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid xs={12} md={4}>
                                <FormControl>
                                    <FormLabel>{t("surname")} *</FormLabel>
                                    <Input type="text"
                                           value={billingDetails.surname}
                                           onChange={e => {setBillingDetails({...billingDetails, surname: e.target.value})}}
                                           placeholder={t("surname")}
                                           error={billingDetails.surname.trim() === ""}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid xs={12} md={4}>
                                <FormControl>
                                    <FormLabel>{t("vat")} *</FormLabel>
                                    <Input type="text"
                                           value={billingDetails.vat}
                                           onChange={e => {setBillingDetails({...billingDetails, vat: e.target.value})}}
                                           placeholder={t("vat")}
                                           error={billingDetails.vat.trim().length < 6 || billingDetails.vat.trim().length > 28}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid xs={12} md={6}>
                                <FormControl>
                                    <FormLabel>{t("country")} *</FormLabel>
                                    <Autocomplete
                                        options={countries}
                                        getOptionLabel={option => option.name}
                                        value={countries.find((a) => a.code === billingDetails.country) || null}
                                        onChange={(e, newValue) => {
                                            if (newValue) {
                                                setBillingDetails({...billingDetails, country: newValue.code});
                                            }
                                        }}
                                        placeholder={t("country")}
                                        error={billingDetails.country === ""}
                                        renderOption={(props, option) => (
                                            <AutocompleteOption {...props}>
                                                {/* eslint-disable-next-line react/jsx-no-undef */}
                                                <ListItemDecorator>
                                                    <img
                                                        loading="lazy"
                                                        width="20"
                                                        srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                                                        src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                                                        alt=""
                                                    />
                                                </ListItemDecorator>
                                                <ListItemContent sx={{ fontSize: 'sm' }}>
                                                    {option.name}
                                                </ListItemContent>
                                            </AutocompleteOption>
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid xs={12} md={6}>
                                <FormControl>
                                    <FormLabel>{t("city")} *</FormLabel>
                                    <Input type="text"
                                           value={billingDetails.city}
                                           onChange={e => {setBillingDetails({...billingDetails, city: e.target.value})}}
                                           placeholder={t("city")}
                                           error={billingDetails.city.trim() === ""}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid xs={10} md={10}>
                                <FormControl>
                                    <FormLabel>{t("address")} *</FormLabel>
                                    <Input type="text"
                                           value={billingDetails.address}
                                           onChange={e => {setBillingDetails({...billingDetails, address: e.target.value})}}
                                           placeholder={t("address")}
                                           error={billingDetails.address.trim() === ""}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid xs={2} md={2}>
                                <FormControl>
                                    <FormLabel>{t("streetnumber")} *</FormLabel>
                                    <Input type="text"
                                           value={billingDetails.streetnumber}
                                           onChange={e => {setBillingDetails({...billingDetails, streetnumber: e.target.value})}}
                                           placeholder={t("streetnumber")}
                                           error={billingDetails.streetnumber.trim() === ""}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Card>
                    <Button
                        disabled={
                            billingDetails.name.trim() === "" ||
                            billingDetails.surname.trim() === "" ||
                            billingDetails.vat.trim().length < 6  || billingDetails.vat.trim().length > 28 ||
                            billingDetails.country === "" ||
                            billingDetails.city.trim() === "" ||
                            billingDetails.address.trim() === "" ||
                            billingDetails.streetnumber.trim() === "" ||
                            loading
                        }
                        onClick={() => {
                            uploadBillingDetails()
                                .then(() => {
                                    window.location.href = "/pay"
                                })
                        }}
                    >
                        {t("next")}
                    </Button>
                </Stack>
            </Container>
        </Box>
    )

    async function uploadBillingDetails() {
        setLoading(true)
        try {
            const user = firebase.auth().currentUser;
            if (!user) {
                return
            }
            const token = await user.getIdToken();

            const response = await fetch(`${APIurl}/uploadUserBillingDetails`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    data: billingDetails,
                    uid: user.uid,
                })
            })
            if (!response.ok) {
                const error = await response.json();
                alert(error);
                return;
            }

            return await response.json();
        } catch (e: unknown) {
            alert(e)
        } finally {
            setLoading(false)
        }
    }
}